module.exports = "<div class=\"u-talk-btn\" v-if=\"isShow\" @click=\"toggle()\">\r\n    <i class=\"u-icon u-icon-talk\"></i>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/phpStudy/PHPTutorial/WWW/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/menu/talk-btn.html
// module id = 57
// module chunks = 0 1 2 3 4 5 6 7 8 9